<template>
  <div>
    <!-- Mobile Viewer -->
    <vs-popup v-if="!isDesktop && detail" fullscreen id="mobile-viewer-detail" class="pdf-viewer-mobile-popup" title @close="closePdfMaximized"
      :active.sync="pdfViewerMobile" :style="insetStyle">
      <template v-if="detail.displayDetail">
        <div class="new-header-popup" v-if="!displayPdfMobile">
          <feather-icon icon="ChevronLeftIcon" @click.stop="closeSidebar()" class="back-header-navigation"
           ></feather-icon>
          <!-- <h4 class="item-commodity align-self-center"></h4> -->
          <!-- <div class="btn-region-pdf-viewer-mobile">
            <vs-button
              class="download-content-mobile"
              radius
              type="filled"
              icon-pack="feather"
              icon="icon-download"
              @click.stop="onDownloadFile"
              v-if="canDownloadFile"
            ></vs-button>
            <vs-button
              v-if="detail.document"
              radius
              type="filled"
              icon-pack="feather"
              icon="icon-maximize"
              @click.stop="displayPdfMobile = true"
            ></vs-button>
          </div> -->
        </div>
        <!-- REMOVED PDF FROM MOBILE -->
        <!-- <div class="pdf-viewer-mobile-popup-header" v-if="displayPdfMobile">
          <feather-icon icon="ChevronLeftIcon" @click.stop="displayPdfMobile = false" class="cursor-pointer mr-4"
            svg-classes="w-6 h-6"></feather-icon>
          <div class="btn-region-pdf-viewer-mobile">
            <vs-button radius type="filled" icon-pack="feather" icon="icon-zoom-out"
              @click.stop="scaleMobile -= 0.25"></vs-button>
            <vs-button radius type="filled" icon-pack="feather" icon="icon-zoom-in"
              @click.stop="scaleMobile += 0.25"></vs-button>
            <vs-button radius type="filled" icon-pack="feather" icon="icon-download" @click.stop="onDownloadFile"
              v-if="canDownloadFile"></vs-button>
          </div>
        </div> -->
        <!-- REMOVED PDF FROM MOBILE -->

        <!--
        <div class="nav-options w-full">
        <accessibility-view
          :isDesktop="isDesktop"
          :canDownloadFile="canDownloadFile"
          :canSpeechText="canSpeechText"
          :isPlaying="isPlaying"
          :rateTextSpeechLabel="rateTextSpeechLabel"
          :showVolume="showVolume"
          @update-zoom-compact="updateZoomCompact"
          @update-zoom-default="updateZoomDefault"
          @update-zoom-big="updateZoomBig"
          @update-contrast="updateContrast"
          @update-format-align-left="updateFormatAlignLeft"
          @update-format-align-center="updateFormatAlignCenter"
          @update-format-align-right="updateFormatAlignRight"
          @update-rate-speed="changeRateSpeech"
          @pause-speech-text="onPause"
          @download-file="onDownloadFile"
        ></accessibility-view>
      </div>-->
        <div class="pdf-viewer-mobile-popup-content" :style="`zoom: ${currentZoomDetail}`">

          <div class="mobile-popup-content-detail" v-if="!displayPdfMobile">
            <h5 class="font-bold chapeu">
              {{ chapeu }}
            </h5>
            <h2 class="item-chapeu font-semibold view">
              {{ getTitle }}
            </h2>
            <div><br></div>
            <div v-if="summaryContent" class="resume-field-mobile mt-5" v-html="summaryContent"></div>
            <!-- <div
              class="content-btn-informative-back-to-top"
              :class="{'fade-in': displayBackToTopBtn, 'fade-out': !displayBackToTopBtn}"
            >
            <vs-button
                v-if="displayBackToTopBtn"
                icon-pack="feather"
                icon="icon-arrow-up"
                class="shadow-lg btn-back-to-top"
                @click.stop="onBackToTop()"
              />
            </div> -->

            <div>
              <div class="body-news">
                <!-- Avatar -->
                <!-- <dropdown-user-info :avatarUrl="detail.author.image_path" :username="detail.author.name"
                  :resume="detail.author.resume" :isDesktop="isDesktop" :displayUserInfo="true"></dropdown-user-info> -->
                  <!-- <author-info class="author w-full mt-3" :author="detail.author" @open-author="$emit('open-author', $event)"></author-info> -->
                <!-- End of Avatar -->


                <div class="tags">
                  <div class="date-last-update">
                    <p class="item-date" v-if="isReport && canDisplayDateField" ><b>{{ $t('NEWS_DETAIL').Report_Date }}</b>
                      {{ formatFullDate(detail.dt_publish, {dateStyle: "short"})  }}
                    </p>
                    <span class="item-date" v-if="!isReport && canDisplayDateField" ><b>{{ $t('NEWS_DETAIL').Publish_Date }}</b>
                      {{ formatFullDate(detail.dt_publish, { dateStyle: "short" }) }}
                    </span>
                  </div>
                </div>
                <div class="chips mt-3 mb-3">
                  <div class="badge badge-imp" v-if="isImportant" @click="onFilter('important', true)">
                    <div class="badge-wrap">
                      <span class="badge-text-reader">
                        {{ $t("BADGES").Important }}
                      </span>
                    </div>
                  </div>
                  <div class="badge live liveview" v-if="detail.inLive" @click.stop="onFilter('inLive', true)">
                    <div class="badge-wrap">
                      <!-- <span class="badge-icon">
                        <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7 2.333c2.577 0 4.667 2.09 4.667 4.667S9.577 11.667 7 11.667 2.333 9.577 2.333 7 4.423 2.333 7 2.333zm0 1.05c-1.997 0-3.617 1.62-3.617 3.617 0 1.997 1.62 3.617 3.617 3.617 1.997 0 3.617-1.62 3.617-3.617 0-1.997-1.62-3.617-3.617-3.617z">
                          </path>
                        </svg>
                        <span class="badge-icon-inner"><svg aria-hidden="true" focusable="false"
                            viewbox="0 0 14 14">
                            <path
                              d="M7 9.567c1.418 0 2.567-1.15 2.567-2.567 0-1.418-1.15-2.567-2.567-2.567-1.418 0-2.567 1.15-2.567 2.567 0 1.418 1.15 2.567 2.567 2.567z">
                            </path>
                          </svg>
                        </span>
                      </span> -->
                      <span class="">{{ $t("BADGES").InLive }}</span>
                    </div>
                  </div>

                  <span v-if="detail.highlight" @click.stop="onFilter('highlights', true)">
                    <vs-chip class="filter-chip highlights-selected-filter">{{ $t("REPORT_FILTER").Filter_Highlights
                    }}</vs-chip>
                  </span>
                  <span @click="onFilter('subject', getSubjectData(detail.subjects))">
                    <vs-chip class="filter-chip subject-selected-filter">{{ getSubjectName(detail.subjects) }}</vs-chip>
                  </span>
                  <span v-if="detail.exclusive" @click.stop="onFilter('exclusive', true)">
                    <vs-chip class="filter-chip exclusive-chip">{{ $t("BADGES").Exclusive }}</vs-chip>
                  </span>
                  <span v-if="isDisclosureAnnouncement" @click.stop="onFilter('disclosureAnnouncement', true)">
                    <vs-chip class="filter-chip disclosure-announcement-badge">{{ $t("BADGES").Announcement
                    }}</vs-chip>
                  </span>
                  <span v-if="isDisclosureInvite" @click.stop="onFilter('disclosureInvite', true)">
                    <vs-chip class="filter-chip disclosure-invite-badge">{{ $t("BADGES").Invite }}</vs-chip>
                  </span>
                  <span v-if="detail.periodicity" @click.stop="onFilter('periodicity', detail.periodicity)">
                    <vs-chip class="filter-chip periodicity-selected-filter">{{ periodicityName }}</vs-chip>
                  </span>
                  <span v-if="detail.characteristic" @click.stop="onFilter('characteristic', detail.characteristic)">
                    <vs-chip class="filter-chip characteristic-selected-filter">{{ characteristicName }}</vs-chip>
                  </span>
                  <div class="flex">
                    <vx-tooltip :text="$t('BUTTONS').Save_Announcement" position="right" delay=".1s">
                        <vs-button
                          v-if="canSaveScheduleItem"
                          radius
                          size="small"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-save"
                          @click.stop="$emit('save-schedule-news', detail)"
                        >
                        </vs-button>
                      </vx-tooltip>
                  </div>
                </div>
                <div class="mobile-download mb-4">
                  <hr v-if="canDownloadFile" />
                  <div class="download-card-content" v-if="canDownloadFile" @click.stop="onDownloadFile" ref="download-content" id="mobile-download-content">
                    <feather-icon icon="DownloadIcon" class="cursor-pointer icon-down mr-1 mt-1"></feather-icon>
                    <div class="document-name">
                      {{ detail.document.original_filename }}
                    </div>
                  </div>
                  <hr v-if="canDownloadFile" />
                </div>
              </div>
              <template>
                <author-info class="author-view w-full mt-5 mb-2 flex author-high"  :displayName="true" :author="detail.author" @open-author="$emit('open-author', $event)"></author-info>

              </template>
              <!-- <dropdown-user-info :avatarUrl="detail.author.image_path" :username="detail.author.name" :resume="detail.author.resume" :isDesktop="isDesktop" :displayUserInfo="false" class="author"></dropdown-user-info> -->
              <vs-row v-if="canDownloadFile" class="mt-5" id="mobile-download-content">
                <div class="download-card-content items-center cursor-pointer w-full mb-3" @click.stop="onDownloadFile" ref="download-content">
                  <feather-icon icon="DownloadIcon" class="cursor-pointer icon-down mt-1"></feather-icon>
                  <div class="document-name">
                    {{ detail.document.original_filename }}
                  </div>
                </div>
                  <!-- <div class="viewbody flex-update" v-if="!isDesktop && showSpinner">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="rotate-button" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
                  </div> -->
              </vs-row>

              <div :title="getMobileTitle()" class="body-news-mobile">
                <!-- <template slot="actions">
                  <span class="item-date" v-if="!isItemNews">{{detail.reportDateFormat}}</span>
                  <span class="item-date" v-if="isItemNews">{{ detail.data_object | moment("'from'") }}</span>
                </template> -->
                <div @click="openImage()" :class="[imageCardClass]">
                  <img style="width: 100%;" :src="imageUrl" v-if="hasImageUrl" />
                </div>
                <!-- <div v-if="hasImageUrl" class="lead-more-image" @click="openImage()">
                  <span>{{$t('REPORT').View_More}}</span>
                </div> -->
                <div class="description-image mb-3" :class="{ '': isDesktop }" v-if="detail.image_description && hasImageUrl">
                  {{ detail.image_description }}
                </div>
                <!-- Pedido para retirar campos de anuncio e convite [2024-04-26] -->
                <!-- <div v-if="isDisclosureAnnouncement || isDisclosureInvite">
                  <vs-list>
                    <vs-list-item :title="$t('NEWS_DETAIL').Kind_Event">
                      {{
                        detail.eventScheduleType == 1
                        ? $t("NEWS_DETAIL").Type_Online
                        : $t("NEWS_DETAIL").Type_Presential
                      }}
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Start_Event">
                      {{
                        formatFullDate(detail.eventScheduleDuration_dateTo, {
                          dateStyle: "short"
                        })
                      }}
                      {{ detail.eventScheduleDuration_hourTo }}
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').End_Event" v-if="!detail.eventScheduleAllDay && detail.eventScheduleDuration_dateFrom">
                      {{
                        formatFullDate(detail.eventScheduleDuration_dateFrom, {
                          dateStyle: "short"
                        })
                      }}
                      {{ detail.eventScheduleDuration_hourFrom }}
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Price" v-if="detail.eventSchedulePrice">
                      {{ detail.eventSchedulePrice }}
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Event_Details" v-if="detail.eventScheduleLink">
                      <span class="cursor-pointer link" @click.stop="openExternalLink(detail.eventScheduleLink)">{{ $t('NEWS_DETAIL').Link }}</span>
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Related_Event" v-if="detail.eventScheduleRelatedNews && isAuthenticated">
                      <span class="cursor-pointer link" @click.stop="$emit('openEventScheduleRelatedNews',detail.eventScheduleRelatedNews)">{{ $t('NEWS_DETAIL').Open }}</span>
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Event_Location" v-if="detail.eventScheduleLocation">
                    </vs-list-item>
                    <div v-html="detail.eventScheduleLocation" class="iframe-maps"></div>
                  </vs-list>
                </div> -->

                <!-- <feather-icon v-if="isPlaying && showVolume" icon="Volume1Icon" class="cursor-pointer icon-down" @click="onSpeech(detail)"></feather-icon> -->
                 <!-- <div class="speech" v-if="canSpeechText && isDesktop">
                  <button class="speech-audio" @click="onSpeech(detail)">
                    <feather-icon
                      v-if="isPlaying && showVolume"
                      icon="PauseIcon"
                      class="cursor-pointer icon-down"
                      @click.stop="onPause()"
                    ></feather-icon>
                    <feather-icon
                      v-if="!isPlaying && showVolume"
                      icon="PlayIcon"
                      class="cursor-pointer icon-down"
                      @click.stop="onSpeech(detail)"
                    ></feather-icon>
                    <span v-if="showVolume">{{ $t("REPORT").Hear_Text }}</span>
                  </button>
                  <button
                    class="speech-rate"
                    @click.stop="changeRateSpeech"
                    v-if="!isPlaying"
                  >
                    <span>{{ rateTextSpeechLabel }}</span>
                  </button>
                </div>  -->

                <vs-row vs-w="12" v-if="detail.eventScheduleIsInvite" style="display: block">
                  <h3>{{ $t("NEWS_DETAIL").Invite }}</h3>
                  <div>
                    <small><b>{{ $t("NEWS_DETAIL").Type }}:</b>
                      {{
                        detail.eventScheduleType == 1
                        ? $t("NEWS_DETAIL").Type_Online
                        : $t("NEWS_DETAIL").Type_Presential
                      }}</small>
                  </div>
                  <div>
                    <small><b>{{ $t("NEWS_DETAIL").All_Day }}:</b>
                      {{ translateBoolean(detail.eventScheduleAllDay) }}</small>
                  </div>
                  <div>
                    <small><b>{{ $t("NEWS_DETAIL").Start_Date }}:</b>
                      {{
                        formatFullDate(detail.eventScheduleDuration_dateTo, {
                          dateStyle: "short"
                        })
                      }}
                      <!-- {{ detail.eventScheduleDuration_hourTo }} -->
                      </small>
                  </div>
                  <div v-if="!detail.eventScheduleAllDay">
                    <small><b>{{ $t("NEWS_DETAIL").Final_Date }}:</b>
                      {{
                        formatFullDate(detail.eventScheduleDuration_dateFrom, {
                          dateStyle: "short"
                        })
                      }}
                      <!-- {{ detail.eventScheduleDuration_hourFrom }} -->
                      </small>
                  </div>
                  <div v-if="detail.eventScheduleLocation">
                    <h3>{{ $t("NEWS_DETAIL").Location }}</h3>
                    <div v-html="detail.eventScheduleLocation"></div>
                    <!-- <iframe
                      :src="getLocationLink"
                      width="100%"
                      height="50%"
                      frameborder="no"
                      sandbox="allow-same-origin"
                      style="border:0"
                      loading="lazy"
                      allowfullscreen
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe> -->
                  </div>
                  <div>
                    <small><b>{{ $t("NEWS_DETAIL").Price }}:</b>{{ detail.eventSchedulePrice }}</small>
                  </div>
                  <div v-if="detail.eventScheduleLink">
                    <small><b>{{ $t("NEWS_DETAIL").Link }}:</b>
                      <span class="cursor-pointer link" @click.stop="openExternalLink(detail.eventScheduleLink)">{{ $t('NEWS_DETAIL').Link }}</span>
                    </small>
                  </div>
                  <div v-if="detail.eventScheduleRelatedNews && isAuthenticated" class="">
                    <small><b>{{ $t("NEWS_DETAIL").Related_Event }}:</b>
                      <span class="cursor-pointer link" @click.stop="
                        $emit(
                          'openEventScheduleRelatedNews',
                          detail.eventScheduleRelatedNews
                        )
                      ">{{ $t('NEWS_DETAIL').Open }}</span></small>
                  </div>
                </vs-row>
                <!-- <div v-if="detailContent" class="resume-field-mobile mt-5" v-html="detailContent"></div> -->
                <!-- <div
                  v-if="detail.content.body"
                  class="resume-field-mobile 2"
                  v-html="detailContent"
                ></div> -->
              </div>

              <!-- <div class="consulting-multimedia" v-if="isItemConsulting || isItemNews"> -->
              <div class="consulting-multimedia" v-if="hasMultimedia">
                <div v-if="hasAudio" class="mt-3">
                  <podcast-page ref="podcastpage" :detail="detail" :currentCommodity="currentCommodity"></podcast-page>
                  <!-- <audio>
                    <source :src="audioLink" :type="audioType" />
                  </audio> -->
                  <!-- <vue-plyr ref="detailPlyrAudio"></vue-plyr> -->
                </div>

                <!-- youtube iframe with progressive enhancement (extra queries after the url to optimize the embed) -->
                <div class="youtube-container" v-if="hasYoutube && displayMedia">
                  <iframe :src="youtubeLink" allowfullscreen allowtransparency scrolling="no"
                    frameborder="no"
                    sandbox="allow-same-origin allow-scripts allow-popups allow-presentation allow-forms allow-modals allow-downloads allow-pointer-lock allow-top-navigation allow-popups-to-escape-sandbox" width="100%" height="100%">
                  </iframe>
                  <!-- <div class="plyr__video-embed">
                  </div> -->
                  <!-- <vue-plyr ref="detailPlyrYoutube"></vue-plyr> -->
                </div>
                <!-- youtube -->
                <!-- <div class="youtube-container" v-if="hasYoutube">
                  <iframe :src="youtubeLink" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                </div> -->
                <!-- end youtube -->

                <!-- Soundcloud -->
                <div class="soundcloud-container" v-if="hasSoundCloud">
                  <iframe id="sc-widget2" :src="soundCloudLink" width="100%" height="200" scrolling="no" frameborder="no"
                    sandbox="allow-same-origin allow-scripts"></iframe>
                </div>
                <!-- End soundcloud -->
                <!-- Spotify -->
                <div class="spotify-container" v-if="hasSpotify">
                  <iframe :src="spotifyLink" width="100%" height="200" frameborder="0" allowtransparency="true"
                    allow="encrypted-media"></iframe>
                </div>
                <!-- End Spotify -->
              </div>

              <div v-if="detailContent" class="resume-field-mobile mt-5" v-html="detailContent"></div>

              <!-- Office renderer -->
              <!-- REMOVED XLS FROM MOBILE -->
              <!--
              <div v-if="isXls" id="iframe-xls">
                <iframe :src='officeLink'
                        @load="xlsIframeLoaded"
                        sandbox="allow-same-origin allow-scripts allow-forms"
                        width='100%' height='650px' frameborder='0'></iframe>
              </div>
              -->
              <!-- End of Office renderer -->

              <!-- REMOVED PDF FROM MOBILE -->
              <!-- <div v-if="isPdf" class="pdfview">
                <PdfViewer :isConsulting="isItemConsulting" :isNews="isItemNews" :isMaximized="false" :url="pdfUrl"
                  :dataId="detail._id" :title="getTitle" :scale="scaleMobile" @closePdfViewerEvent="closePdfViewer"
                  @updateScaleViewerEvent="updateScaleInfoView"></PdfViewer>
              </div> -->
              <!-- REMOVED PDF FROM MOBILE -->

              <!-- <div
                class="btn-display-pdf-view-mobile cursor-pointer"
                @click.stop="displayPdfMobile = true"
                v-if="isPdf"
              >
                <div class="icon-pdf"></div>
                <div class="text-pdf-view">
                  <h5 class="text-primary">Visualizar PDF</h5>
                  <span>Clique para visualizar o PDF</span>
                </div>
              </div> -->
              <!-- <div
                class="btn-display-pdf-view-mobile cursor-pointer"
                @click.stop="onDownloadFile"
                v-if="canDownloadFile"
              >
                <div class="icon-xls"></div>
                <div class="text-pdf-view">
                  <h5 class="text-primary">
                    {{ $t("REPORT").Download_Spreadsheet }}
                  </h5>
                  <span>{{ $t("REPORT").Download_Spreadsheet_Text }}</span>
                </div>
              </div> -->
            </div>
          </div>
          <!-- Related News -->
          <!-- <vs-row vs-w="12" class="mb-5">
            <div class="related_news" >
              <div v-if="relatedNews.free_title && relatedNews.free_text && relatedNews.news && relatedNews.news.length > 0">
                <h5 class="related-news-free-title-mobile" v-html="relatedNews.free_title"></h5>
                <p class="related-news-free-text-mobile" v-html="relatedNews.free_text"></p>
              </div>
              <div v-else-if="!relatedNews.free_title && !relatedNews.free_text && relatedNews.news && relatedNews.news.length > 0">
                <h5 class="related-news-free-title">Notícias Relacionadas:</h5>
              </div>
              <div class="content-related-news">
                <h5
                  class="link"
                  v-for="(item, index) in relatedNews.news"
                  :key="index"
                  @click.stop="$emit('openRelatedNews', item.id)"
                >
                  {{`• ${item.content.title.data}` }}
                </h5>
              </div>
            </div>
          </vs-row> -->
                <!-- End Related News -->
          <div class="others-news mt-5 mb-5 mobile" v-if="detail.tags && detail.tags.length > 0">
            <h5 class="mb-3 ">{{$t('NEWS_DETAIL').Read_More}}</h5>

          </div>
          <div class="chips mt-5 mb-5">
              <span class="mt-2" v-for="(tag, index) in detail.tags" :key="index" @click.stop="onFilter('searchQuery', tag.name)">
                <vs-chip class="filter-chip">{{ formattedTagName(tag.name) }}</vs-chip>
              </span>
              <span class="mt-2" v-if="detail.exclusive" @click.stop="onFilter('exclusive', true)">
                <vs-chip class="filter-chip exclusive-chip">{{ $t("BADGES").Exclusive }}</vs-chip>
              </span>
              <span class="mt-2" v-if="detail.periodicity" @click.stop="onFilter('periodicity', detail.periodicity)">
                <vs-chip class="filter-chip periodicity-selected-filter">{{ periodicityName }}</vs-chip>
              </span>
              <span class="mt-2" v-if="detail.characteristic" @click.stop="onFilter('characteristic', detail.characteristic)">
                <vs-chip class="filter-chip characteristic-selected-filter">{{ characteristicName }}</vs-chip>
              </span>
          </div>
          <!-- REMOVED PDF FROM MOBILE -->
          <!-- <div class="mobile-popup-content-pdf" v-if="displayPdfMobile && isPdf">
            <PdfViewer :isConsulting="isItemConsulting" :isNews="isItemNews" :isMaximized="true" :url="pdfUrl"
              :dataId="detail._id" :title="getTitle" :scale="scaleMobile" @closePdfViewerEvent="closePdfViewer"
              @updateScaleViewerEvent="updateScaleInfoView"></PdfViewer>
          </div> -->
          <!-- REMOVED PDF FROM MOBILE -->


        </div>

          <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
      </template>
      <template v-else>
        <div class="pdf-viewer-mobile-popup-header">
          <feather-icon icon="ChevronLeftIcon" @click.stop="closeSidebar()" class="cursor-pointer"
            svg-classes=""></feather-icon>
        </div>
        <private-content
          class="mt-10"
          @open-register="$emit('open-register')"
          @close="closeSidebar"
        ></private-content>
        <!-- <custom-content
          class="mt-10"
          v-if="!isAuthenticated"
          :isDesktop="isDesktop"
          :displayCloseBtn="false"
          @open-register="$emit('open-register')"
        /> -->
        <!-- <div v-if="!contentPrivate.url && contentPrivate.text" class="content-private-text">
          <iframe width="100%" height="100%" frameborder="no"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms" :srcdoc="contentPrivate.text"></iframe>
        </div>
        <div v-if="contentPrivate.url" class="content-private-iframe">
          <iframe :src="contentPrivate.url" width="100%" height="100%" frameborder="no"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>
        </div> -->
      </template>
    </vs-popup>
    <!-- End of Mobile Pdf Viewer -->

    <!-- Desktop Fullscreen Pdf Viewer -->
    <vs-popup v-if="isDesktop" fullscreen class :title="getTitle" @close="closePdfMaximized"
      :active.sync="activePdfViewerMaximized" :style="insetStyle">
      <div @contextmenu.prevent>
        <!-- Maximized toolbar -->
        <PDFToolbar :scale="scaleMaximized" :isMaximized="activePdfViewerMaximized" :displayDownloadBtn="canDownloadFile"
          @change="changeScaleMaximized" @maximize="maximizePdf" @printPdf="printPdf" @download="onDownloadFile"
          class="header-item" />
        <PdfViewer v-if="activePdfViewerMaximized && isPdf" :isConsulting="isItemConsulting" :isNews="isItemNews"
          :isMaximized="true" :url="pdfUrl" :dataId="detail._id" :title="getTitle" :scale="scaleMaximized"
          @closePdfViewerEvent="closePdfViewer" @updateScaleViewerEvent="updateScaleInfoView"></PdfViewer>
      </div>
    </vs-popup>
    <!-- End of Desktop Fullscreen Pdf Viewer -->

    <!-- Desktop Fullscreen Xls Viewer -->
    <vs-popup v-if="isDesktop && isXls" fullscreen class :title="getTitle" @close="closeXlsMaximized"
              :active.sync="activeXlsViewerMaximized" :style="insetStyle">
      <div @contextmenu.prevent>
        <vx-tooltip text="Minimizar" position="right" delay=".3s">
          <feather-icon icon="MinimizeIcon" class="cursor-pointer" @click.stop="maximizeXls(false)"></feather-icon>
        </vx-tooltip>
        <iframe :src='officeLink'
                @load="xlsIframeLoaded"
                sandbox="allow-same-origin allow-scripts allow-forms"
                width='100%' height='650px' frameborder='0'></iframe>
      </div>
    </vs-popup>
    <!-- End of Desktop Fullscreen Xls Viewer -->

    <!--
          'sidebar-view-custom-cardview': isCardView,
          'sidebar-view-custom-cardview-reduced': isCardView && reduceFilterSidebar
        -->

    <!-- <vs-sidebar v-if="isDesktop" click-not-close parent="#email-app" :hidden-background="true" -->
    <vs-sidebar v-if="isDesktop" click-not-close parent="#view-detail" :hidden-background="true"
      class="full-vs-sidebar email-view-sidebar items-no-padding sidebar-view-custom" :class="{
        'sidebar-view-custom-reduced': reduceFilterSidebar,
        'sidebar-view-custom-mobile': !isDesktop,
        'sidebar-view-custom-mosaic': isMosaicView,
        'sidebar-view-ticker-top-mosaic': isAuthenticated && !isProfileFree && isDesktop && isMosaicView && canDisplayTicker && tickerViewAtTheTop,
        'sidebar-view-custom-mosaic-reduced': isMosaicView && reduceFilterSidebar,
        'sidebar-view-custom-calendar': isCalendarView,
        'sidebar-view-with-ticker-top': isAuthenticated && canDisplayTicker && tickerViewAtTheTop,
        'sidebar-view-custom-with-ticker-bottom': isAuthenticated && canDisplayTicker && !tickerViewAtTheTop
      }" v-model="isSidebarActive" position-right>
      <div v-if="displayWeatherPage">
        <weather-page
          v-if="displayWeatherPage"
        ></weather-page>
      </div>
      <div v-if="detail && !resetView && !displayWeatherPage" id="informative-view-content" class="mail-sidebar-content h-full">
        <template v-if="isListView || isListViewDetailed || isCardView">
          <div class="button-chevr" v-if="displayArrow">
            <vx-tooltip text="Minimizar Detalhes" position="right" delay=".3s" v-if="isMaximizedDetail">
              <feather-icon icon="ChevronsRightIcon" class="cursor-pointer" @click.stop="$emit('maximize-detail', false)"></feather-icon>
            </vx-tooltip>
            <vx-tooltip text="Maximizar Detalhes" position="right" delay=".3s" v-if="!isMaximizedDetail">
              <feather-icon icon="ChevronsLeftIcon" class="cursor-pointer" @click.stop="$emit('maximize-detail', true)"></feather-icon>
            </vx-tooltip>
          </div>
        </template>
        <div
          id="scroll-area"
          class="scroll-area"
          :class="{
            'scroll-area-private': !detail.displayDetail,
            'scroll-area-private-desktop': !detail.displayDetail && contentPrivate && !isProfileFree,
          }"
          :settings="settings">
          <div class="h-full" :class="{ 'scroll-area-private-content': contentPrivate }">
          <vs-card class="bg-reader h-full" :class="{'display-contents': !detail.displayDetail}">
            <!-- new detail -->
            <div slot="header" v-if="canDisplayCloseSidebar">
              <feather-icon icon="ChevronLeftIcon" @click="closeSidebar()" class="cursor-pointer mr-4"
                svg-classes="w-6 h-6"></feather-icon>
            </div>

            <div :style="`zoom: ${currentZoomDetail}`" class="" :class="{
              'p-8': detail.displayDetail,
              'h-full w-full': !detail.displayDetail
            }">
              <div v-if="detail.displayDetail" class="header-desk">


                  <h4 class="item-commodity align-self-center">
                    {{ chapeu }}
                  </h4>

                <h1 class="mt-1">{{ getTitle }}</h1>
                <!-- <vs-row vs-w="12" v-if="detail.characteristic"><small><b>Caracteristica:</b> {{detail.characteristic.namePtBr}}</small></vs-row>
              <vs-row vs-w="12" v-if="detail.periodicity"><small><b>Periodicidade:</b> {{detail.periodicity.namePtBr}}</small></vs-row> -->
                <div v-if="summaryContent" v-html="summaryContent" class="sumary-title mt-3" />
                <div class="chips mt-3">
                  <div class="badge badge-imp" v-if="isImportant" @click="onFilter('important', true)">
                    <div class="badge-wrap">
                      <span class="badge-text-reader">
                        {{ $t("BADGES").Important }}
                      </span>
                    </div>
                  </div>
                  <div class="badge live liveview" v-if="detail.inLive" @click.stop="onFilter('inLive', true)">
                    <div class="badge-wrap">
                      <!-- <span class="badge-icon">
                        <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7 2.333c2.577 0 4.667 2.09 4.667 4.667S9.577 11.667 7 11.667 2.333 9.577 2.333 7 4.423 2.333 7 2.333zm0 1.05c-1.997 0-3.617 1.62-3.617 3.617 0 1.997 1.62 3.617 3.617 3.617 1.997 0 3.617-1.62 3.617-3.617 0-1.997-1.62-3.617-3.617-3.617z">
                          </path>
                        </svg><span class="badge-icon-inner"><svg aria-hidden="true" focusable="false"
                            viewbox="0 0 14 14">
                            <path
                              d="M7 9.567c1.418 0 2.567-1.15 2.567-2.567 0-1.418-1.15-2.567-2.567-2.567-1.418 0-2.567 1.15-2.567 2.567 0 1.418 1.15 2.567 2.567 2.567z">
                            </path>
                          </svg>
                        </span>
                      </span> -->
                      <span class="">{{ $t("BADGES").InLive }}</span>
                    </div>
                  </div>

                  <span v-if="detail.highlight" @click.stop="onFilter('highlights', true)">
                    <vs-chip class="filter-chip highlights-selected-filter">{{ $t("REPORT_FILTER").Filter_Highlights
                    }}</vs-chip>
                  </span>
                  <span @click="onFilter('subject', getSubjectData(detail.subjects))">
                    <vs-chip class="filter-chip subject-selected-filter">{{ getSubjectName(detail.subjects) }}</vs-chip>
                  </span>
                  <span v-if="detail.exclusive" @click.stop="onFilter('exclusive', true)">
                    <vs-chip class="filter-chip exclusive-chip">{{ $t("BADGES").Exclusive }}</vs-chip>
                  </span>
                  <span v-if="isDisclosureAnnouncement" @click.stop="onFilter('disclosureAnnouncement', true)">
                    <vs-chip class="filter-chip disclosure-announcement-badge">{{ $t("BADGES").Announcement
                    }}</vs-chip>
                  </span>
                  <span v-if="isDisclosureInvite" @click.stop="onFilter('disclosureInvite', true)">
                    <vs-chip class="filter-chip disclosure-invite-badge">{{ $t("BADGES").Invite }}</vs-chip>
                  </span>
                  <span v-if="detail.periodicity" @click.stop="onFilter('periodicity', detail.periodicity)">
                    <vs-chip class="filter-chip periodicity-selected-filter">{{ periodicityName }}</vs-chip>
                  </span>
                  <span v-if="detail.characteristic" @click.stop="onFilter('characteristic', detail.characteristic)">
                    <vs-chip class="filter-chip characteristic-selected-filter">{{ characteristicName }}</vs-chip>
                  </span>

                  <div class="flex">
                    <vx-tooltip :text="$t('BUTTONS').Save_Announcement" position="right" delay=".1s">
                        <vs-button
                          v-if="canSaveScheduleItem"
                          radius
                          size="small"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-save"
                          @click.stop="$emit('save-schedule-news', detail)"
                        >
                        </vs-button>
                      </vx-tooltip>
                  </div>
                </div>
                <div class="box-info-details mt-3">
                  <!-- <span><b>Conteúdo:</b> {{detail.newsContent.map(item => item.namePtBr).join(',')}}</span> -->
                  <!-- <span><b>País:</b> {{detail.country.map(item => item.name).join(',')}}</span> -->
                  <span v-if="isReport && detail.reportType"><b>{{ $t('NEWS_DETAIL').Report }}</b> {{ getNameTranslateField(detail.reportType) }}</span>
                  <span v-if="isReport && canDisplayDateField"><b>{{ $t('NEWS_DETAIL').Report_Date }}</b>
                    {{
                      formatFullDate(detail.dt_report, {
                        dateStyle: "short"
                      })
                    }}</span>
                    <span v-if="!isReport && canDisplayDateField"><b>{{ $t('NEWS_DETAIL').Publish_Date }}</b>
                    {{
                      formatFullDate(detail.dt_publish, { dateStyle: "short" })
                    }}</span>

                  <author-info class="author w-full mt-3 flex author-high" :displayName="true" :author="detail.author" @open-author="$emit('open-author', $event)"></author-info>
                </div>
              </div>

              <template v-if="detail.displayDetail">
                <vs-divider></vs-divider>
                <vs-row v-if="canDownloadFile && !isPdf">
                  <div class="download-card-content items-center cursor-pointer" @click.stop="onDownloadFile" ref="download-content" id="download-content">
                    <feather-icon icon="DownloadIcon" class="cursor-pointer icon-down mt-1"></feather-icon>
                    <div class="document-name">
                      {{ detail.document.original_filename }}
                    </div>
                  </div>
                </vs-row>
                <vs-divider v-if="canDownloadFile && !isPdf"></vs-divider>

                <!-- Speech text -->

                <!-- content body -->
                <!-- div-image-align-left -->
                <!-- div-image-align-center -->
                <!-- div-image-align-right -->
                <div class="speech mb-5 mt-5" v-if="canSpeechText">
                  <speech-text-component :detail="detail"></speech-text-component>
                    <!-- <button class="speech-audio" @click="onSpeech(detail)">
                      <feather-icon
                        v-if="isPlaying && showVolume"
                        icon="PauseIcon"
                        class="cursor-pointer icon-down"
                        @click.stop="onPause()"
                      ></feather-icon>
                      <feather-icon
                        v-if="!isPlaying && showVolume"
                        icon="PlayIcon"
                        class="cursor-pointer icon-down"
                        @click.stop="onSpeech(detail)"
                      ></feather-icon>
                      <span v-if="showVolume" class="text-spech-text" :class="{'playing off': isPlaying}">{{ $t("REPORT").Hear_Text }}</span>
                      <span v-if="showVolume" class="text-spech-text" :class="{'playing off': !isPlaying}">{{ $t("REPORT").Hear_Text_Hearing }} {{ getTitle }}</span>
                    </button>
                    <button
                      class="speech-rate"
                      @click.stop="changeRateSpeech"
                      v-if="!isPlaying"
                    >
                      <span>{{ rateTextSpeechLabel }}</span>
                    </button> -->
                </div>
                <vs-row vs-w="12" v-if="hasImageUrl" :class="[imageCardClass]">

                  <div class="w-full row-image"><img class="detail-image" :src="imageUrl" @click="openImage()" /></div>
                  <!-- <div v-if="hasImageUrl" class="lead-more-image" @click="openImage()">
                    <span>{{$t('REPORT').View_More}}</span>
                  </div> -->
                  <div class="description-image mb-3" :class="{ '': isDesktop }" v-if="detail.image_description">
                    {{ detail.image_description }}
                  </div>
                </vs-row>

                <!-- <div v-if="isDisclosureAnnouncement || isDisclosureInvite" class="list-event">
                  <vs-list>
                    <vs-list-item :title="$t('NEWS_DETAIL').Kind_Event">
                      {{
                        detail.eventScheduleType == 1
                        ? $t("NEWS_DETAIL").Type_Online
                        : $t("NEWS_DETAIL").Type_Presential
                      }}
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Start_Event" v-if="detail.eventScheduleDuration_dateTo">
                      {{
                        formatFullDate(detail.eventScheduleDuration_dateTo, {
                          dateStyle: "short"
                        })
                      }}
                      {{ detail.eventScheduleDuration_hourTo }}
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').End_Event" v-if="!detail.eventScheduleAllDay && detail.eventScheduleDuration_dateFrom">
                      {{
                        formatFullDate(detail.eventScheduleDuration_dateFrom, {
                          dateStyle: "short"
                        })
                      }}
                      {{ detail.eventScheduleDuration_hourFrom }}
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Price" v-if="detail.eventSchedulePrice">
                      {{ detail.eventSchedulePrice }}
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Event_Details" v-if="detail.eventScheduleLink">
                      <span class="cursor-pointer link" @click.stop="openExternalLink(detail.eventScheduleLink)">{{ $t('NEWS_DETAIL').Link }}</span>
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Related_Event" v-if="detail.eventScheduleRelatedNews && isAuthenticated">
                      <span class="cursor-pointer link" @click.stop="$emit('openEventScheduleRelatedNews',detail.eventScheduleRelatedNews)">{{ $t('NEWS_DETAIL').Open }}</span>
                    </vs-list-item>
                    <vs-list-item :title="$t('NEWS_DETAIL').Event_Location" v-if="detail.eventScheduleLocation">
                    </vs-list-item>
                    <div v-html="detail.eventScheduleLocation" class="iframe-maps"></div>
                  </vs-list>
                </div>
                <vs-row vs-w="12" v-if="isDisclosureAnnouncement || isDisclosureInvite" style="display: block">
                </vs-row> -->

                <vs-divider v-if="imageUrl" class=""></vs-divider>

                <vs-row vs-w="12" v-if="hasAudio">
                  <podcast-page ref="podcastpage" :detail="detail"></podcast-page>
                </vs-row>
                <vs-row class="youtube-container" v-if="hasYoutube && displayMedia">
                  <!-- <iframe :src="youtubeLink" allowfullscreen allowtransparency allow="autoplay" scrolling="no"
                    frameborder="no" sandbox="allow-same-origin allow-scripts">
                  </iframe> -->
                  <vue-plyr ref="detailPlyrYoutube" :options="{ pauseOnDestroy: false }">
                    <div class="plyr__video-embed">
                      <iframe :src="youtubeLink" allowfullscreen allowtransparency allow="autoplay" scrolling="no"
                        frameborder="no" sandbox="allow-same-origin allow-scripts allow-popups allow-presentation allow-forms allow-modals allow-downloads allow-pointer-lock allow-top-navigation allow-popups-to-escape-sandbox">
                      </iframe>
                    </div>
                  </vue-plyr>
                </vs-row>
                <vs-row vs-w="12" class="soundcloud-container" v-if="hasSoundCloud">
                  <iframe id="sc-widget" :src="soundCloudLink" width="100%" height="200" scrolling="no" frameborder="no"
                    sandbox="allow-same-origin allow-scripts"></iframe>
                </vs-row>
                <vs-row vs-w="12" class="spotify-container" v-if="hasSpotify">
                  <iframe :src="spotifyLink" width="100%" height="200" frameborder="0" allowtransparency="true"
                    allow="encrypted-media" sandbox="allow-same-origin allow-scripts"></iframe>
                </vs-row>

                <vs-divider v-if="detailContent" class=""></vs-divider>

                <div class="content-field" v-if="detailContent">
                  <p v-if="detail.eventScheduleLink" v-html="eventLink"></p>
                  <span v-if="detailContent" v-html="detailContent"></span>
                  <!-- <span v-if="detailContent" v-html="detail.content.body.data"></span> -->
                </div>

                <vs-divider v-if="detailContent" class=""></vs-divider>

                <vs-row vs-w="12" v-if="isPdf">
                  <!-- DESKTOP PDF VIEWER -->
                  <div class="card-pdf-minimized" ref="download-content" id="download-content">
                    <!-- v-if="isPdfViewerVisible" -->
                    <PDFToolbar :scale="scaleMinimized" :isMaximized="false" :displayDownloadBtn="canDownloadFile"
                      @change="changeScaleMinimized" @maximize="maximizePdf" @printPdf="printPdf" @download="onDownloadFile"
                      :displayZoomInBtn="false" :displayZoomOutBtn="false"
                      class="header-item" />
                    <PdfViewer :isConsulting="isItemConsulting" :isNews="isItemNews" :url="pdfUrl" :dataId="detail._id"
                      :title="getTitle" :scale="scaleMinimized" @closePdfViewerEvent="closePdfViewer"
                      @updateScaleViewerEvent="updateScaleInfoView" @maximize="maximizePdf"></PdfViewer>
                  </div>
                </vs-row>

                <!-- Office renderer -->
                <vx-tooltip v-if="isXls" text="Maximizar" position="left" delay=".3s">
                  <feather-icon icon="MaximizeIcon" class="cursor-pointer" @click.stop="maximizeXls(true)"></feather-icon>
                </vx-tooltip>

                <vs-row v-if="isXls" id="iframe-xls">
                  <iframe :src='officeLink'
                          @load="xlsIframeLoaded"
                          sandbox="allow-same-origin allow-scripts allow-forms"
                          width='100%' height='650px' frameborder='0'></iframe>
                </vs-row>
                <!-- End of Office renderer -->

                <!-- Related News -->
                <vs-row vs-w="12" class="mb-5">
                  <div class="related_news">
                    <div v-if="relatedNews.free_title && relatedNews.free_text && relatedNews.news && relatedNews.news.length > 0">
                      <h5 class="related-news-free-title" v-html="relatedNews.free_title"></h5>
                      <p class="related-news-free-text" v-html="relatedNews.free_text"></p>
                    </div>
                    <div v-else-if="relatedNews.news && relatedNews.news.length > 0 && !(relatedNews.free_text && relatedNews.free_title)">
                      <h5 class="related-news-free-title">{{$t('NEWS_DETAIL').Read_More}}:</h5>
                    </div>
                    <div class="content-related-news" v-if="relatedNews.news && relatedNews.news.length > 0">
                      <h5
                        class="link"
                        v-for="(item, index) in relatedNews.news"
                        :key="index"
                        @click.stop="$emit('openRelatedNews', item.id)"
                      >
                        {{`• ${item.title}` }}
                      </h5>
                    </div>
                  </div>
                </vs-row>
                <!-- End Related News -->

                <vs-row vs-w="12" v-if="detail.tags && detail.tags.length > 0" class="mb-5">
                  <div class="others-news mt-5 mb-5">
                    <h5 class="mb-3 lead-more">{{$t('NEWS_DETAIL').Read_More}}</h5>
                    <div class="chips mt-5 mb-5">
                      <span v-for="(tag, index) in detail.tags" :key="index"
                        @click.stop="onFilter('searchQuery', tag.name)">
                        <vs-chip class="filter-chip">{{ formattedTagName(tag.name) }}</vs-chip>
                      </span>
                      <span v-if="detail.exclusive" @click.stop="onFilter('exclusive', true)">
                        <vs-chip class="filter-chip exclusive-chip">{{ $t("BADGES").Exclusive }}</vs-chip>
                      </span>
                      <span v-if="detail.periodicity" @click.stop="onFilter('periodicity', detail.periodicity)">
                        <vs-chip class="filter-chip periodicity-selected-filter">{{ periodicityName }}</vs-chip>
                      </span>
                      <span v-if="detail.characteristic" @click.stop="onFilter('characteristic', detail.characteristic)">
                        <vs-chip class="filter-chip characteristic-selected-filter">{{ characteristicName }}</vs-chip>
                      </span>
                    </div>
                  </div>
                </vs-row>
              </template>
              <template v-if="!detail.displayDetail">
                <private-content
                  @open-register="$emit('open-register')"
                  @close="closeSidebar"
                ></private-content>
                <!-- <custom-content
                  class="mt-3"
                  v-if="!isAuthenticated"
                  :isDesktop="isDesktop"
                  :displayCloseBtn="false"
                  @open-register="$emit('open-register')"
                /> -->
                <!-- <div v-if="!contentPrivate.url && contentPrivate.text" v-html="contentPrivate.text" class="content-private-text"> -->
                <!-- <div v-if="!contentPrivate.url && contentPrivate.text" class="content-private-text h-full">
                  <iframe width="100%" height="100%" frameborder="no" sandbox="allow-same-origin"
                    :srcdoc="contentPrivate.text"></iframe>
                </div>
                <div v-if="contentPrivate.url" class="content-private-iframe">
                  <iframe :src="contentPrivate.url" width="100%" height="100%" frameborder="no"
                    sandbox="allow-same-origin"></iframe>
                </div> -->
                <!-- <feather-icon icon='LockIcon' svgClasses='h-12 w-12' class='ml-1' />
              Conteúdo privado apenas para assinante -->
              </template>
            </div>
          </vs-card>
        </div>
        </div>
      </div>
      <div class="selected-emp" v-else-if="!displayWeatherPage">
        <div class="message-emp">
          <p class="ilustration"><img :src="require('@/assets/images/pages/report.svg')" /></p>
          <p>Nenhum item ao lado selecionado.</p>
          <!-- <p>Nada selecionado</p> -->
        </div>
      </div>
    </vs-sidebar>

    <vs-popup v-if="hasImageUrl && imageMaximized" fullscreen class="popup-image-maximized pop-image-full w-full h-full" title
      :active.sync="imageMaximized" :style="insetStyle">
      <div class="image-maximized-toolbar">
        <!-- <vs-button radius type="filled" icon-pack="feather" icon="icon-zoom-in"
          @click.stop="maximizeImageZoomIn"></vs-button>
        <vs-button radius type="filled" icon-pack="feather" icon="icon-zoom-out"
          @click.stop="maximizeImageZoomOut"></vs-button> -->
      </div>
      <div class="div-img w-full h-full" :style="imagePathStyle">
        <!-- <img :src="imageUrl" @contextmenu.prevent class="" /> -->
        <!-- <div class="descri-image-full w-full" :class="{ 'pt-4': isDesktop }" v-if="detail.image_description">
        {{ detail.image_description }}
        </div> -->
      </div>

    </vs-popup>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import PDFToolbar from "../widgets/pdf/PDFToolbar";
import PdfViewer from "../widgets/PdfViewer";
import reportService from "../../../providers/reportService";
import printJS from "print-js";
import AppConstants from "../../../appConstants";
import DropdownUserInfo from "../widgets/dropdown-user-info/DropdownUserInfo.vue";
import { EventBus } from "../../../event-bus";
import TextToSpeech from "../../../plugins/TextToSpeech";
import translateFieldHelper from "../../../helpers/translate-field-helper";
import convertDatetimeHelper from "../../../helpers/convert-datetime-helper";
import { CONTENT } from "../../../enums/enum-content";
import ChangeZoom from "../../../plugins/ChangeZoom";
import HorizontalNavMenuGroup from "../../../layouts/components/horizontal-nav-menu/HorizontalNavMenuGroup.vue";
import localStorageHelper from "../../../helpers/local-storage-helper";
import VxCard from "../../../components/vx-card/VxCard.vue";
import AccessibilityView from "./AccessibilityView.vue";
import CustomContent from '../CustomContent.vue';
import AuthorInfo from '../../../layouts/components/customizer/AuthorInfo.vue';
import generalHelper from '../../../helpers/general-helper';
import formatFieldHelper from '../../../helpers/format-field-helper';
import PrivateContent from '../private-content/PrivateContent.vue';
import SpeechTextComponent from '../widgets/SpeechTextComponent.vue';
import checkDeviceTypeHelper from '../../../helpers/check-device-type-helper';
import PodcastPage from '../widgets/PodcastPage.vue';
import WeatherPage from '../weather/WeatherPage.vue';
import { getInsetStyle } from "../../../helpers/inset-style-helper";

export default {
  props: {
    detail: {
      required: true,
      default: {}
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    reduceFilterSidebar: Boolean,
    isConsulting: Boolean,
    isNews: Boolean,
    isMaximizedDetail: Boolean,
    displayWeatherPage: Boolean,
    currentCommodity: {
      require: true
    },
    },
  data() {
    return {
      scaleMobile: 1.4,
      scaleMaximized: 2.5,
      scaleMinimized: 0.75,
      titlePopup: "",
      showThread: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5
      },
      isPdfViewerVisible: false,
      activePdfViewerMaximized: false,
      isXlsViewerVisible: false,
      activeXlsViewerMaximized: false,
      pdfViewerMobile: false,
      iframeXlsVisible: false,
      displayPdfMobile: false,
      imageMaximized: false,
      maximizedImageSizeWidth: 0,
      currentMediaData: {
        youtubeCurrentTime: 0,
        youtubePlayed: false,
        audioCurrentTime: 0,
        audioPlayed: false
      },
      displayMedia: true,
      resetView: false,
      imagePathStyle: '',
      relatedNews: {},
    };
  },
  watch: {
    isSidebarActive(value) {
      if (!this.isDesktop) {
        this.pdfViewerMobile = value;
      }
      if (!value) {
        this.closeSidebar();
        this.isPdfViewerVisible = false;
        setTimeout(() => {
          this.showThread = false;
        }, 500);
      } else {
        this.currentMediaData.youtubePlayed = false;
        this.currentMediaData.audioPlayed = false;
        // this.$store.dispatch('updateYoutubeIsPlaying', false);
        // this.$store.dispatch('updateAudioIsPlaying', false);

        if (this.detail) {
          if (this.detail.soundcloud) {
            this.loadScriptSoundCloud();
          }
          // this.titlePopup = this.detail.content.title.data;
        }

        if (this.isPdf) {
          setTimeout(() => {
            this.isPdfViewerVisible = true;
          }, 800);
        }
      }
    },
    "detail.uuid"() {
      this.updateMediaData();
      if (!this.detail) return;
      this.resetView = true;
      this.getImageStyle();
      this.cancelSpeech();
      // if (this.detail._id != value._id) {
      //   // this.$store.dispatch('updateYoutubeIsPlaying', false);
      //   // this.$store.dispatch('updateAudioIsPlaying', false);
      // }
      if (!this.isDesktop) {
        if (this.detail.youtubeId) {
          this.displayMedia = false;
          setTimeout(() => {
            this.displayMedia = true;
          }, 300);
        }
      }
      if (this.detail.youtubeId) {
        // console.log("has youtube");
        setTimeout(() => {
          try {
            this.youtubePlayer.on("play", () => {
              console.log("youtube played");
              this.currentMediaData.youtubePlayed = true;
              // this.$store.dispatch('updateYoutubeIsPlaying', true);
            });
            this.youtubePlayer.on('pause', () => {
              this.currentMediaData.youtubePlayed = false;
              // this.$store.dispatch('updateYoutubeIsPlaying', false);
            });
          } catch (error) {
            // console.log(error);
          }
        }, 1000);
      } else if (this.detail.audio) {
        setTimeout(() => {
          if (this.podcastPage) {
            this.$nextTick(() => {
              try {
                // console.log('[podcastPage]',this.podcastPage)
                this.podcastPage.audioPlayer.on("play", () => {
                  // console.log('audio played');
                  this.currentMediaData.audioPlayed = true;
                  // this.$store.dispatch('updateAudioIsPlaying', true);
                });
                this.podcastPage.audioPlayer.on('pause', () => {
                  this.currentMediaData.audioPlayed = false;
                  // this.$store.dispatch('updateAudioIsPlaying', false);
                });
              } catch (error) {}
            });
          }
        }, 1000);
      }
      // if (this.isDesktop) {
      // }
      this.relatedNews = Object.assign({});
      setTimeout(() => {
        this.resetView = false;
        this.onBackToTop();
      }, 100);
    }
  },
  computed: {
    insetStyle() {
      return getInsetStyle();
    },
    userProfile() {
      return this.$store.state.AppActiveUser.profile;
    },
    isProfileFree() {
      return this.userProfile == AppConstants.USER_PROFILE.FREE;
    },
    isS4Login() {
      return localStorageHelper.getS4Login();
    },
    scheduleData() {
      return this.$store.state.scheduleData || [];
    },
    canSaveScheduleItem() {
      return this.detail.type == 'calendar' && (this.detail.disclosureType == 1 || this.detail.disclosureType == 2) && this.scheduleData.findIndex(item => item._id == this.detail._id) < 0;
    },
    canDisplayTicker() {
      return this.$store.state.canDisplayTicker;
    },
    tickerViewAtTheTop() {
      return this.$store.state.tickerViewAtTheTop;
    },
    imageCardClass() {
      if (this.detail.content.body && !this.detail.content.body.data) {
        return ''
      }
      if (!this.isDesktop) {
        return 'div-image-align-center';
      }
      if (this.isFormatAlignLeft) return 'div-image-align-left';
      else if (this.isFormatAlignCenter) return 'div-image-align-center';
      else if (this.isFormatAlignRight) return 'div-image-align-right';
      return '';
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    displayArrow() {
      return this.windowWidth >= 1200
    },
    tinnyScreen() {
      return generalHelper.tinnyScreen(this.windowWidth);
    },
    smallScreen() {
      return generalHelper.smallScreen(this.windowWidth);
    },
    canDisplayCloseSidebar() {
      return this.isMosaicView || this.tinnyScreen || this.smallScreen || this.isCalendarView;
    },
    isCalendarView() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.CALENDAR;
    },
    getTitle() {
      if (!this.detail) return "";
      if (
        this.detail.newsContent[0].code == CONTENT.STATISTIC ||
        this.detail.newsContent[0].code == CONTENT.EXPORTS ||
        this.detail.newsContent[0].code == CONTENT.INFORMATIVE
      ) {
        return translateFieldHelper.getTranslateField(
          "name",
          this.detail.reportType
        );
      }
      return this.detail.content.title.data;
    },
    isDisclosureAnnouncement() {
      return (
        this.detail.disclosureType ==
        AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT
      );
    },
    isDisclosureInvite() {
      return (
        this.detail.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE
      );
    },
    contentPrivate() {
      return this.$store.state.contentPrivate || { text: "" };
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    pdfUrl() {
      if (!this.isAuthenticated) {
        if (this.detail && this.detail.document)
        return this.detail.document.image_path;
      }
      return "";
    },
    canSpeechText() {
      return generalHelper.canSpeechText(this.detail, this.isDesktop);
      // return (
      //   !this.isPdf && !this.isXls && !checkDeviceTypeHelper.isPlatformAndroid()
      // );
    },
    isPaused() {
      return this.$store.state.textSpeechIsPaused;
    },
    isPlaying() {
      return this.$store.state.textSpeechIsPlaying;
    },
    rateTextSpeech() {
      return this.$store.state.AppActiveUser.rateTextSpeech;
    },
    rateTextSpeechLabel() {
      switch (this.rateTextSpeech) {
        case 1.0:
          return "1x";
        case 1.5:
          return "1.5x";
        case 2.0:
          return "2x";
        default:
          return "1x";
      }
    },
    isListView() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.LISTVIEW;
    },
    isListViewDetailed() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED;
    },
    isCardView() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.CARDVIEW;
    },
    isMosaicView() {
      return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.MOSAIC;
    },
    characteristicName() {
      return this.detail.characteristic[`name${this.$i18n.locale}`];
    },
    periodicityName() {
      return this.detail.periodicity[`name${this.$i18n.locale}`];
    },
    eventLink() {
      if (this.detail.eventScheduleLink) {
        return this.linkify(this.detail.eventScheduleLink);
      }
      return "";
    },
    detailContent() {
      if (this.detail.content.body) {
        return this.linkify(this.detail.content.body.data);
      }
      return "";
    },
    summaryContent() {
      if (this.detail.content.abstract) {
        return this.linkify(this.detail.content.abstract.data);
      }
      return "";
    },
    youtubePlayer() {
      return this.$refs.detailPlyrYoutube.player;
    },
    podcastPage() {
      return this.$refs.podcastpage;
    },
    audioPlayerCurrentTime() {
      return this.podcastPage.audioPlayer.currentTime;
    },
    audioPlayer() {
      return this.$refs.detailPlyrAudio.player;
    },
    imageMaximizedWidthStyle() {
      return `width: calc(100% - ${this.maximizedImageSizeWidth}px);`;
    },
    hasMultimedia() {
      return (
        this.hasYoutube ||
        this.hasSoundCloud ||
        this.hasAudio ||
        this.hasSpotify
      );
    },
    isItemConsulting() {
      return this.isConsulting || !!this.detail.isConsulting;
    },
    isItemNews() {
      return (
        this.detail.newsContent.findIndex(item => item.code == CONTENT.NEWS) >=
        0
      );
    },
    isReport() {
      return (
        this.detail.newsContent.findIndex(
          item =>
            item.code == CONTENT.INFORMATIVE ||
            item.code == CONTENT.EXPORTS ||
            item.code == CONTENT.STATISTIC
        ) >= 0
      );
    },
    canDisplayDateField() {
      return (
        this.detail.newsContent.findIndex(
          item =>
            item.code != CONTENT.CONSULTING_COURSES
        ) >= 0
      );
    },
    hasSoundCloud() {
      return !!this.detail.soundcloud;
    },
    hasSpotify() {
      return !!this.detail.spotify;
    },
    spotifyLink() {
      return `${AppConstants.URL_SPOTIFY_EMBED}${this.detail.spotify}`;
    },
    soundCloudLink() {
      return `${AppConstants.URL_SOUNDCLOUD_EMBED}${this.detail.soundcloud
        }&show_teaser=false&`;
    },
    hasYoutube() {
      if (!this.detail) {
        return false;
      }
      return !!this.detail.youtubeId;
    },
    youtubeLink() {
      // "https://www.youtube.com/embed/bTqVqk7FSmY?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1"
      // return `${AppConstants.URL_YOUTUBE_EMBED}${
      //   this.detail.youtubeId
      // }?iv_load_policy=3&modestbranding=0&playsinline=1&showinfo=0&rel=0&enablejsapi=1`;
      return `${AppConstants.URL_YOUTUBE_EMBED}${this.detail.youtubeId
        }?modestbranding=1&playsinline=0&showinfo=0&enablejsapi=1&origin=${window.location.origin
        }&widgetid=1`;
    },
    officeLink() {
      if (this.detail && this.detail.document) {
        const fileUrl = this.detail.document.image_path;
        return `https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`;
      } else {
        return '';
      }
    },
    hasAudio() {
      if (!this.detail) {
        return false;
      }
      return !!this.detail.audio;
    },
    audioLink() {
      if (this.detail && this.detail.audio) {
        return this.detail.audio.image_path;
      }
      return "";
    },
    audioType() {
      if (this.detail && this.detail.audio) {
        // return `audio/${this.detail.audio_filename.substring(this.detail.audio_filename.lastIndexOf(".") + 1).toUpperCase()}`;
        return `audio/${this.detail.audio.extension}`;
      }
      return "";
    },
    imageUrl() {
      if (this.detail && this.detail.image) {
        return this.detail.image.image_path;
      }
      return ``;
    },
    hasImageUrl() {
      if (!this.detail) {
        return false;
      }
      return !!this.detail.image;
    },
    resumo() {
      if (this.detail && this.detail.content.abstract) {
        return this.detail.content.abstract.data;
      }
      return "";
    },
    chapeu() {
      if (this.detail && this.detail.hat[0]) {
        return this.detail.hat[0].name.toUpperCase();
      }
      return "";
    },
    isImportant() {
      if (!this.detail) {
        return false;
      }
      return this.detail.importance > 0;
    },
    showVolume() {
      return this.getTextToSpeech(this.detail);
    },
    canDownloadFile() {
      if (!this.detail) {
        return false;
      }
      if (!this.detail.document) {
        return false;
      }
      return this.detail.download_document;
    },
    isPdf() {
      if (this.detail) {
        if (!this.detail.document) {
          return false;
        }
        return this.detail.document.extension == "pdf";
      }
      return false;
    },
    isXls() {
      if (!this.detail) {
        return false;
      }
      if (!this.detail.document) {
        return false;
      }
      return (
        this.detail.document.extension == "xls" ||
        this.detail.document.extension == "xlsx"
      );
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    badgeTypeClass() {
      if (this.detail.document) return "attach-document";
      if (this.detail.audio) return "audio";
      if (this.detail.youtubeId) return "video";
      if (this.detail.soundcloud) return "podcast";
      if (this.detail.spotify) return "podcast";
      return "";
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    currentFormatAlignDetail() {
      return this.activeUserInfo.formatAlignDetail;
    },
    currentZoomDetail() {
      return this.activeUserInfo.zoomDetail;
    },
    isZoomCompact() {
      return this.currentZoomDetail === AppConstants.ZOOM.COMPACT;
    },
    isZoomDefault() {
      return this.currentZoomDetail === AppConstants.ZOOM.DEFAULT;
    },
    isZoomMedium() {
      return this.currentZoomDetail === AppConstants.ZOOM.MEDIUM;
    },
    isZoomBig() {
      return this.currentZoomDetail === AppConstants.ZOOM.BIG;
    },
    isFormatAlignLeft() {
      if (!this.detail.content.body && !this.detail.content.body.data) return false;
      return (
        this.currentFormatAlignDetail === AppConstants.DETAIL_FORMAT_ALIGN.LEFT
      );
    },
    isFormatAlignCenter() {
      if (!this.detail.content.body && !this.detail.content.body.data) return false;
      return (
        this.currentFormatAlignDetail ===
        AppConstants.DETAIL_FORMAT_ALIGN.CENTER
      );
    },
    isFormatAlignRight() {
      if (!this.detail.content.body && !this.detail.content.body.data) return false;
      return (
        this.currentFormatAlignDetail === AppConstants.DETAIL_FORMAT_ALIGN.RIGHT
      );
    },
    getLocationLink() {
      console.log("[location]", this.detail.eventScheduleLocation);
      return `${this.detail.eventScheduleLocation}`;
      // return `${this.detail.eventScheduleLocation}&output=embed`;
    },
    currentTheme() {
      return this.$store.state.theme;
    },
    contrastIcon() {
      if (this.currentTheme == AppConstants.THEME.DARK) {
        return "icon-moon";
      }
      return "icon-sun";
    }
  },
  methods: {
    formattedTagName(tag) {
      if (!this.isDesktop) {
        if (tag && tag.length > 40) return `${tag.substring(0,40)}...`;
      }
      return tag;
    },
    updateRelatedNewsData(val) {
      this.relatedNews = val;
    },
    async getImageStyle() {
      if (this.detail && this.detail.image) {
        if (this.detail.image.image_path_hires) {
          const exist = await generalHelper.checkImageExist(this.detail.image.image_path_hires);
          if (exist) {
            this.imagePathStyle = `background-image:url('${this.detail.image.image_path_hires}')`;
            return;
          }
        }

        if (this.detail && this.detail.image && this.detail.image.image_path) {
          this.imagePathStyle = `background-image:url('${this.detail.image.image_path}')`;
        }
      }
      // return `background-image:url('${image}')`;
    },
    getNameTranslateField(item) {
      return translateFieldHelper.getTranslateField('name', item);
    },
    onBackToTop() {
      if (this.$refs['scroll-area']) {
        this.$refs['scroll-area'].scrollTop = 0;
      }
    },
    xlsIframeLoaded() {
      try {
        this.$vs.loading.close("#iframe-xls > .con-vs-loading");
      } catch (error) {
        console.log('[xlsIframeLoaded]', error)
      }
    },
    onClose() {
      this.$emit("closeSidebar");
    },
    onFilter(field, val) {
      console.log("onFilter", { field: field, value: val });
      this.$emit("filter", { field: field, value: val });
    },
    updateFormatAlignLeft() {
      localStorageHelper.updateFormatAlignDetail(
        AppConstants.DETAIL_FORMAT_ALIGN.LEFT
      );
    },
    updateFormatAlignCenter() {
      localStorageHelper.updateFormatAlignDetail(
        AppConstants.DETAIL_FORMAT_ALIGN.CENTER
      );
    },
    updateFormatAlignRight() {
      localStorageHelper.updateFormatAlignDetail(
        AppConstants.DETAIL_FORMAT_ALIGN.RIGHT
      );
    },
    updateZoomCompact() {
      ChangeZoom.setDetailCompact();
    },
    updateZoomDefault() {
      ChangeZoom.setDetailDefault();
    },
    updateZoomMedium() {
      ChangeZoom.setDetailMedium();
    },
    updateZoomBig() {
      ChangeZoom.setDetailBig();
    },
    updateContrast() {
      if (this.currentTheme == AppConstants.THEME.DARK) {
        localStorageHelper.updateTheme(AppConstants.THEME.LIGHT);
      } else if (this.currentTheme == AppConstants.THEME.LIGHT) {
        localStorageHelper.updateTheme(AppConstants.THEME.DARK);
      }
    },
    translateBoolean(val) {
      return translateFieldHelper.translateBooleanToLocale(val);
    },
    formatFullDate(val, obj) {
      return convertDatetimeHelper.formatFullDate(val, obj);
    },
    formatDate(val, obj) {
      return convertDatetimeHelper.formatDate(val, obj);
    },
    openMobileDetails(value) {
      this.pdfViewerMobile = value;
    },
    getImageSrc(eventScheduleRelatedNews) {
      if (eventScheduleRelatedNews.news) {
        if (eventScheduleRelatedNews.news.thumb) {
          return eventScheduleRelatedNews.news.thumb.image_path;
        }
        if (eventScheduleRelatedNews.news.image) {
          return eventScheduleRelatedNews.news.image.image_path;
        }
      }
      return require("@/assets/images/informative/placeholder115.svg");
    },
    openEventScheduleRelatedNews(data) {
      console.log("openEventScheduleRelatedNews", data);
      if (data.news) {
        this.$emit("openEventScheduleRelatedNews", data.news);
      }
    },
    linkify(inputText) {
      let text = formatFieldHelper.replaceAnchorTagToText(inputText);
      if (this.isDesktop) {
        text = formatFieldHelper.linkify(text);
      } else {
        text = formatFieldHelper.linkifyMobile(text);
        // const pattern1 = /<a[^>]*?\bhref="([^"]*)"[^>]*>(.*?)<\/a>/gi;
        // text = inputText.replace(pattern1, '<a href="#" onclick="cordova.InAppBrowser.open(\'$1\', \'_system\');">$2</a>')
      }
      return text;
    },
    closeSidebar() {
      if (this.$store.state.currentMediaData.youtubePlayer.isPlaying) {
        this.currentMediaData.youtubePlayed = true;
      }
      if (this.$store.state.currentMediaData.audioPlayer.isPlaying) {
        this.currentMediaData.audioPlayed = true;
      }
      this.cancelSpeech();
      this.updateMediaData();
      this.$emit("closeSidebar", {
        reportDetail: this.detail,
        currentMediaData: this.currentMediaData
      });
    },
    updateMediaData() {
      // if (!this.isDesktop) return;
      // if (this.$store.state.currentMediaData.youtubePlayer.isPlaying) {
      //   this.$store.dispatch('updateYoutubeCurrentTime', this.youtubePlayer.currentTime);
      if (this.currentMediaData.youtubePlayed) {
        this.currentMediaData.youtubeCurrentTime = this.youtubePlayer.currentTime;
        const temp = JSON.parse(JSON.stringify(this.currentMediaData));
        if (this.youtubePlayer) {
          this.youtubePlayer.pause();
          this.currentMediaData = JSON.parse(JSON.stringify(temp));
        }
      }

      if (this.currentMediaData.audioPlayed) {
        this.currentMediaData.audioCurrentTime = this.podcastPage.audioPlayer.currentTime;
        if (this.podcastPage) {
          this.podcastPage.audioPlayer.pause();
        }
      }
    },
    getMobileTitle() {
      if (this.detail.hat) {
        return this.detail.hat[0].name;
      }

      return "";

    },
    maximizeImageZoomOut() {
      this.maximizedImageSizeWidth += 100;
    },
    maximizeImageZoomIn() {
      this.maximizedImageSizeWidth -= 100;
    },
    openImage() {
      if (this.isDesktop) {
        this.imageMaximized = true;
      } else {
        console.log('[informativeView][openImage]', JSON.stringify(this.detail.image));
        this.$emit('open-image-mobile', this.detail.image);
      }
    },
    onBackPdfViewerMobile() {
      if (this.displayPdfMobile) {
        this.displayPdfMobile = false;
      } else {
        this.closeSidebar();
      }
    },
    printPdf() {
      if (this.isPdf) {
        this.$vs.loading({
          container: "#email-app",
          scale: 0.6
        });

        const params = new URLSearchParams();
        // params.append("download", false);
        // params.append('isConsulting', this.isItemConsulting);
        // params.append('isNews', this.isItemNews);

        if (this.isAuthenticated) {
          reportService
          .readDocumentFile(this.detail._id, params)
          .then(response => {
            const bytes = this.CryptoJS.AES.decrypt(
              response.data,
              AppConstants.PDF_PWD
            );
            const pdfPlain = bytes.toString(this.CryptoJS.enc.Utf8);

            printJS({ printable: pdfPlain, type: "pdf", base64: true });
            this.$vs.loading.close("#email-app > .con-vs-loading");
          })
          .catch(error => {
            console.log(error);
          });
        } else {
          params.append('download', true);
           reportService.downloadReportFile(this.getDocumentURL(), params)
            .then(res => {
              printJS({ printable: window.URL.createObjectURL(new Blob([res.data])), type: "pdf"});
              this.$vs.loading.close("#email-app > .con-vs-loading");
            }).catch(err => console.log(err));
        }

        // reportService
        //   .readDocumentFile(this.getDocumentURL(), params)
        //   .then(response => {
        //     const bytes = this.CryptoJS.AES.decrypt(
        //       response.data,
        //       AppConstants.PDF_PWD
        //     );
        //     const pdfPlain = bytes.toString(this.CryptoJS.enc.Utf8);

        //     printJS({ printable: pdfPlain, type: "pdf", base64: true});
        //     this.$vs.loading.close("#email-app > .con-vs-loading");
        //   })
        //   .catch(error => {
        //     console.log(error);
        //   });
      }
    },
    updateScaleInfoView(scale) {
      // this.scaleMinimized = scale;
      // this.scaleMaximized = scale;
    },
    getDocumentURL() {
      //   return "https://cdn.filestackcontent.com/5qOCEpKzQldoRsVatUPS";
      if (this.detail && this.detail.document) {
        return this.detail.document.image_path;
      }
      return '';
    },
    closePdfViewer() {
      this.isPdfViewerVisible = false;
    },
    maximizeXls(value) {
      if (value) {
        this.closeXlsViewer();
        this.activeXlsViewerMaximized = true;
      } else {
        this.closeXlsMaximized();
      }
    },
    closeXlsViewer() {
      this.isXlsViewerVisible = false;
    },
    closeXlsMaximized() {
      this.activeXlsViewerMaximized = false;
      this.isXlsViewerVisible = true;
    },
    maximizePdf(value) {
      if (value) {
        this.closePdfViewer();
        this.activePdfViewerMaximized = true;
      } else {
        this.closePdfMaximized();
      }
    },
    closePdfMaximized() {
      this.activePdfViewerMaximized = false;
      this.isPdfViewerVisible = true;
    },
    getTextToSpeech(detail) {
      if (
        detail.content.title ||
        detail.content.abstract ||
        detail.content.text
      ) {
        return formatFieldHelper.removeDuplicateItem([
          detail.content.title.data,
          detail.content.abstract.data,
          detail.content.text.data
        ]);
      }
      return false;
    },
    // onSpeech(detail) {
    //   TextToSpeech.onSpeech(this.getTextToSpeech(detail));
    // },
    onPause() {
      TextToSpeech.onPause();
    },
    changeRateSpeech() {
      TextToSpeech.changeRateSpeech();
    },
    cancelSpeech() {
      try {
        TextToSpeech.onPause();
        TextToSpeech.onCancel();
      } catch (error) {
        console.log(error);
      }
    },
    getSubjectName(subjects) {
      return translateFieldHelper.getSubjectName(
        subjects,
        this.currentCommodity
      );
    },
    getSubjectData(subjects) {
      return translateFieldHelper.getSubjectData(
        subjects,
        this.currentCommodity
      );
    },
    removeDownloadSpinner() {
      if (this.isDesktop) {
        this.$vs.loading.close("#download-content > .con-vs-loading");
      } else {
        setTimeout(() => {
          this.$vs.loading.close("#mobile-viewer-detail > .con-vs-loading");
        }, 3 * 100);
      }
    },
    onDownloadFile() {
      if (this.isDesktop) {
        this.$vs.loading({
          container: "#download-content",
          scale: 0.6
        });
      } else {
        this.$vs.loading({
          container: "#mobile-viewer-detail",
          scale: 0.6,
        });
      }
      // this.$vs.loading({
      //   container: this.$refs['download-content'],
      //   scale: 0.6
      // });
      this.$forceUpdate();
      this.$emit("onDownloadFile", this.detail);
    },
    changeScaleMinimized(data) {
      console.log('[changeScaleMinimized]', data);
      if (data < 1 || data > 3) {
        return;
      }
      this.scaleMinimized = data;
      // EventBus.$emit(AppConstants.BUS_EVENT_CHANGE_SCALE_PDF, data);
    },
    changeScaleMaximized(data) {
      // console.log('[changeScaleMaximized]', data);
      if (data < 1 || data > 10) {
        return;
      }
      this.scaleMaximized = data;
    },
    loadScriptSoundCloud() {
      // const widgetIframe = document.getElementById('sc-widget'),
      // widget = SC.Widget(widgetIframe);
      // widget.bind(SC.Widget.Events.READY, function () {
      //   // load new widget
      //   widget.bind(SC.Widget.Events.FINISH, function () {
      //     widget.load(newSoundUrl, {
      //       auto_play: false,
      //       buying: false,
      //       liking: false,
      //       download: false,
      //       sharing: false,
      //       show_artwork: true,
      //       show_comments: false,
      //       show_playcount: false,
      //       show_user: false,
      //       start_track: 0
      //     });
      //   });
      // });
    },
    openExternalLink(link) {
      if (checkDeviceTypeHelper.isNativeApp()) {
        if (checkDeviceTypeHelper.isReactApp()) {
          // TODO - OPEN IN REACT
        } else {
          cordova.InAppBrowser.open(link, '_system');
        }
      } else {
        window.open(link, '_blank');
      }
    }
  },
  mounted() {
    // Voice
    // this.voiceList = this.synth.getVoices();
    // this.synth.onvoiceschanged = () => {
    //   this.voiceList = this.synth.getVoices();
    // };

    // textSpeech.onend = () => {
    //   this.isPlaying = false;
    // };

    EventBus.$on(AppConstants.BUS_EVENT_CLOSE_POPUP, () => {
      this.pdfViewerMobile = false;
      this.displayPdfMobile = false;
    });

    if (this.isDesktop) {
      const that = this;
      document.addEventListener("keyup", e => {
        if (e.ctrlKey && e.code == "KeyC") {
          that.$copyText(AppConstants.COPYRIGHT_TEXT_CLIPBOARD);
        }
      });
    }
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_CLOSE_POPUP);
  },
  hasTextToSpeech() {
      if ( (this.data.content.abstract || this.data.content.text) && !this.hasDocument && this.isDesktop ) {
        return `${this.getTitle} ${
          this.data.content.abstract.data
        } ${this.data.content.text.data}`;
      }
      return false;
    },
  updated() {
    if (this.isXls) {
      // this.$vs.loading({
      //   container: '#iframe-xls',
      //   scale: 0.6,
      // });
      // // Timeout fechar loading
      // setTimeout(() => this.$vs.loading.close("#iframe-xls > .con-vs-loading"), 3 * 1000);
    } else {
      this.$vs.loading.close("#iframe-xls > .con-vs-loading");
    }
  },
  components: {
    VuePerfectScrollbar,
    PdfViewer,
    PDFToolbar,
    DropdownUserInfo,
    HorizontalNavMenuGroup,
    VxCard,
    AccessibilityView,
    CustomContent,
    AuthorInfo,
    PrivateContent,
    SpeechTextComponent,
    PodcastPage,
    WeatherPage,
  }
};
</script>

<style lang="scss">
h3 {
  color: #03673c;
  font-weight: bold;
}

.con-vs-card {
  background: #fff;
  margin-top: 0px;
  width: 100%;
  // min-height: 98%;
  min-height: 100%;
}

.theme-dark .con-vs-card {
  // background: #353e45;
}

.pdf-badge {
  background-color: #bb21d0;
  min-width: 0;
  min-height: 0;
  width: 45px;
  height: 15px;
  font-size: 9px;
  font-weight: 500;
  margin-top: 2px;
}

.download-card {
  height: 40px;
  border-radius: 10px !important;
  // margin-bottom: 50px;
}

.icon-down {
  // margin-top: 6px !important;
  display: block;
  color: #03673c;
}

button.speech-audio {
  width: 100%;
  display: flex;
  height: 35px;
  border-radius: 15px;
  padding: 5px;
  line-height: 25px;
  font-size: 14px;
  background-color: #f5f5f5;
  border: 1px solid #ebebeb;
}
.theme-dark button.speech-audio{
  background-color: #4d5762;
  border: 1px solid #4d5762;
}
.theme-dark button.speech-rate{
  background-color: #333c45;
  border: 1px solid #333c45;
}
.theme-dark button.speech-audio svg{
  color: #FFF;
}
.theme-dark button.speech-audio, button.speech-rate span{
  color: #FFF;
}
button.speech-audio, button.speech-rate span{
  color: #000;
}
.theme-dark .speech-audio, button.speech-rate span{
  color: #FFF;
}
.download-card-content {
  align-items: center;
  // width: 100%;
  display: flex;

  .document-name {
    font-size: 14px;
    margin-left: 10px;
  }

  .feather-icon {
    // right: 30px;
    // position: absolute !important;
    // float: right;
    // margin-left: auto;
  }
}

.vs-card--header {
  box-shadow: none;
}

.theme-dark .vs-card--header {
  // background-color: #353E45;
}

.theme-dark .vs-card--content {
  // background-color: #353E45;
}

#informative-view-content {
  .con-vs-card header {
    justify-content: normal !important;
    padding-left: 15px;
    padding-right: 15px;
  }

  .email-header {
    padding: 0px 10px;
  }

  .chips {
    // margin-top: 13px;
  }

  .item-avatar {
    float: left;
  }

  .item-details {
    display: flex;
    // min-width: 250px;
    // min-width: 370px;
  }

  .items-start {
    align-items: center !important;
  }

  .item-date {
    margin-bottom: 25px;
  }

  .item-right {
    height: 60px;
  }

  .download-report {
    margin-top: 20px;
  }

  .download-report a {
    font-weight: 700;
    font-size: 1.2em;
  }

  .row-user-detail {
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .card-pdf-minimized {
    margin: 0px 2px -10px 2px;
    width: 100%;
  }
}

.sidebar-view-custom {
  .vs-sidebar {
    // max-width: calc(100% - 270px);
    // margin-left: 215px;
    width: 49%;
    // margin-top: 50px;
  }
}

.sidebar-view-custom-reduced {
  .vs-sidebar {
    margin-left: 0px;
    // max-width: calc(100% - 54px);
    width: 60%;
  }
}
.theme-dark .authenticated .vs-popup {
    background: #282e34 !important;
}
.authenticated .vs-popup {
    background: #FFF !important;
}
.sidebar-view-custom-mobile {
  .vs-sidebar {
    margin-left: 0px;
    max-width: 100%;
    width: 100%;
  }
}

.con-vs-popup .vs-popup--content {
  padding: 10px;
}

.sidebar-view-custom-cardview {
  .vs-sidebar {
    // max-width: calc(100% - 270px);
    margin-left: 180px;
    width: calc(100% - 100px);
    max-width: calc(100% - 230px);
    margin-top: 0px;
  }
}

.sidebar-view-custom-cardview-reduced {
  .vs-sidebar {
    width: calc(100% - 54px);
    max-width: calc(100% - 54px);
  }
}

.sidebar-view-custom-mosaic {
  .vs-sidebar {
    // max-width: calc(100% - 270px);
    margin-left: 0px;
    width: calc(100% - 100px);
    max-width: calc(100% - 230px);
    margin-top: 0px;
  }
}

.sidebar-view-custom-mosaic-reduced {
  .vs-sidebar {
    max-width: 100%;
    width: calc(100% - 55px);
  }
}

.pdf-viewer-mobile-popup {
  .vs-popup {
    margin: 0;
    max-width: 100%;
    max-height: 100%;
    border: none;
  }

  .vs-popup--title {
    display: none;
  }

  .vs-popup--header i {
    display: none;
  }

  .vs-popup--content {
    max-height: 100%;
  }

  .btn-display-pdf-view-mobile {
    display: flex;

    .text-pdf-view {
      text-align: center;
      align-self: center;
    }

    .text-pdf-view span {
      color: #ababab;
      font-size: 12px;
      margin-top: 3px;
      font-weight: 500;
      text-align: right;
    }
  }

  .menu-user-dropdown {
    margin-left: 10px;
  }
}

.pdf-viewer-mobile-popup-header {
  display: flex;
  justify-content: space-between;

  span.feather-icon {
    // margin-top: 3px !important;
    margin-bottom: 10px;
    height: 30px;
    // width: 35px;
  }

  h4 {
    // line-height: 37px;
  }

  .badge.live.float-right {
    line-height: 22px;
    font-size: 12px;
    margin-top: 0px;
    height: 25px;
    border: 1px solid #970b00;
  }

  .vs-button {
    margin-top: 0px;
    margin-right: 0px !important;
    margin-left: 6px;
  }

  .btn-region-pdf-viewer-mobile {
    display: flex;
    justify-content: space-between;
  }
}

.pdf-viewer-mobile-popup-content {
  .scroll-area {
    min-height: 500px;
  }

  .row-user-detail {
    margin-right: 0px;
  }

  .card-pdf-minimized {
    margin-right: 0px;
  }

  .chips {
    display: contents;
  }

  .pdf-document {
    // margin-top: 0px;
  }

  .icon-pdf {
    margin-left: -20px;
    margin-right: 15px;
  }

  .btn-display-pdf-view-mobile {
    padding: 10px;
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
    justify-content: center;
  }

  .resume-field-mobile {
    // padding: 0 10px 10px 10px;
  }
}

.resume-field-with-content {
  font-size: 13px;
  font-weight: 200;
}
.theme-dark .desktop .custom-content-scroll::-webkit-scrollbar-thumb, .desktop .user-notification::-webkit-scrollbar-thumb {
    background-color: #5a636c !important;
    border-radius: 10px;
    border: 1px solid #4d5762;
}

.theme-dark .desktop .custom-content-scroll::-webkit-scrollbar-track, .desktop .user-notification::-webkit-scrollbar-track {
    background: #282e34;
}

.theme-dark .content-field {
  color: #FFF !important;
  p{
    color: #FFF !important;
  }
  span{
    color: #FFF !important;
  }
}

@media only screen and (max-width: 600px) {
  .content-field {
    margin-top: 10px;
    white-space: pre-line;
    height: auto;

    img {
      width: 100%;
    }
  }
}

.card-pdf-minimized .vs-card--header {
  div {
    width: 100%;

    .item-date {
      // float: right;
    }
  }
}

.youtube-container {
  width: 100%;
  height: auto;
  border: none;
}

.popup-image-maximized {
  .vs-popup--header {
    height: 0px;

    .vs-popup--close {
      // margin-top: 50px;
      // margin-right: 25px;
    }
  }

  .image-maximized-toolbar {
    display: flex;
    margin-bottom: 10px;
    margin-top: -10px;
  }
}

/* Plyr */
.plyr--full-ui input[type="range"] {
  color: #a8d044 !important;
}

.plyr__control--overlaid {
  background: rgba(0, 0, 0, 0.8) !important;
}

.plyr--video .plyr__control.plyr__tab-focus,
.plyr--video .plyr__control:hover,
.plyr--video .plyr__control[aria-expanded="true"] {
  background: #a8d044 !important;
}

.plyr__control.plyr__tab-focus {
  box-shadow: 0 0 0 5px rgba(168, 208, 68, 0.5) !important;
}

.plyr__menu__container .plyr__control[role="menuitemradio"][aria-checked="true"]::before {
  background: #a8d044 !important;
}

.badge.live.liveview {
  float: left;
  height: 28px;
  line-height: 27px;
  font-size: 1.0rem;
  margin-top: 0px;
  border: 1px solid #9c0b00;
  padding-top: 0px;
}
/* End Plyr */
</style>
